/**
* This class listens to pointer events to determine which input device (mouse, pen, touch, etc.) is being used.
*/
class PointerEventDetector {
  private static _initialized: boolean = false;
  private static _currentPointerType: string = '';

  private constructor() { }

  private static handlePointerEvent(event: PointerEvent): void {
    PointerEventDetector._currentPointerType = event.pointerType;
  }

  public static init(): void {
    if (!PointerEventDetector._initialized) {
      document.body.addEventListener('pointerdown', PointerEventDetector.handlePointerEvent, { capture: true });
      document.body.addEventListener('pointermove', PointerEventDetector.handlePointerEvent, { capture: true });
      PointerEventDetector._initialized = true;
    }
  }

  public static remove(): void {
    document.body.removeEventListener('pointerdown', PointerEventDetector.handlePointerEvent, { capture: true });
    document.body.removeEventListener('pointermove', PointerEventDetector.handlePointerEvent, { capture: true });
    PointerEventDetector._currentPointerType = '';
    PointerEventDetector._initialized = false;
  }

  public static get initialized(): boolean {
    return PointerEventDetector._initialized;
  }

  public static get currentPointerType(): string {
    return PointerEventDetector._currentPointerType;
  }
}

export { PointerEventDetector };
